module.exports = __webpack_public_path__ + "img/Tokyo.789398a0.jpg";